import { Link } from "react-router-dom";
import { Emblem } from "../components/Emblem";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-bg px-4 text-center">
      <Emblem size={64} className="text-muted" />
      <h1 className="mt-6 font-heading text-3xl font-bold">Page not found</h1>
      <p className="mt-2 max-w-sm text-sm text-muted">
        The page you requested does not exist in this portal.
      </p>
      <Link to="/" className="btn btn-primary mt-6 no-underline">
        Return to the portal
      </Link>
    </div>
  );
}
